[
  {
    "id": "info-processing",
    "slug": "info-processing",
    "title": "정보처리기사",
    "category": "국가자격",
    "dataYear": 2026,
    "sourceUrl": "https://www.q-net.or.kr/crf005.do?id=crf00503s02&jmCd=1320&jmInfoDivCcd=B0",
    "checkedAt": "2026-10-19",
    "notice": "2027 일정 공고 전 · 과목과 일정은 2026년 기준이에요. 공식 공고가 우선해요.",
    "supplies": ["수험표 확인", "인정 신분증", "시험장·입실 시간 확인", "공식 지참 준비물 확인"],
    "stages": [
      {
        "id": "필기",
        "subjects": [
          "소프트웨어설계",
          "소프트웨어개발",
          "데이터베이스구축",
          "프로그래밍언어활용",
          "정보시스템구축관리"
        ],
        "nextStage": "실기",
        "minimum": 40,
        "average": 60
      },
      {
        "id": "실기",
        "subjects": ["정보처리 실무"],
        "minimum": 60,
        "average": 60
      }
    ],
    "schedules": [
      {
        "round": "1회",
        "stage": "필기",
        "examDate": "2026-01-30",
        "examEndsOn": "2026-03-03",
        "resultDate": "2026-03-11",
        "registrationWindows": [
          {
            "startsAt": "2026-01-12T01:00:00.000Z",
            "endsAt": "2026-01-15T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "1회",
        "stage": "실기",
        "examDate": "2026-04-18",
        "examEndsOn": "2026-05-06",
        "resultDate": "2026-06-12",
        "registrationWindows": [
          {
            "startsAt": "2026-03-23T01:00:00.000Z",
            "endsAt": "2026-03-26T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "2회",
        "stage": "필기",
        "examDate": "2026-05-09",
        "examEndsOn": "2026-05-29",
        "resultDate": "2026-06-10",
        "registrationWindows": [
          {
            "startsAt": "2026-04-20T01:00:00.000Z",
            "endsAt": "2026-04-23T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "2회",
        "stage": "실기",
        "examDate": "2026-07-18",
        "examEndsOn": "2026-08-05",
        "resultDate": "2026-09-11",
        "registrationWindows": [
          {
            "startsAt": "2026-06-22T01:00:00.000Z",
            "endsAt": "2026-06-25T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "3회",
        "stage": "필기",
        "examDate": "2026-08-07",
        "examEndsOn": "2026-09-01",
        "resultDate": "2026-09-09",
        "registrationWindows": [
          {
            "startsAt": "2026-07-20T01:00:00.000Z",
            "endsAt": "2026-07-23T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "3회",
        "stage": "실기",
        "examDate": "2026-10-24",
        "examEndsOn": "2026-11-13",
        "resultDate": "2026-12-18",
        "registrationWindows": [
          {
            "startsAt": "2026-09-21T01:00:00.000Z",
            "endsAt": "2026-09-28T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      }
    ]
  },
  {
    "id": "electrical-engineer",
    "slug": "electrical-engineer",
    "title": "전기기사",
    "category": "국가자격",
    "dataYear": 2026,
    "sourceUrl": "https://www.q-net.or.kr/crf005.do?id=crf00503s02&jmCd=1150&jmInfoDivCcd=B0",
    "checkedAt": "2026-10-19",
    "notice": "2027 일정 공고 전 · 과목과 일정은 2026년 기준이에요. 공식 공고가 우선해요.",
    "supplies": ["수험표 확인", "인정 신분증", "시험장·입실 시간 확인", "공식 지참 준비물 확인"],
    "stages": [
      {
        "id": "필기",
        "subjects": [
          "전기자기학",
          "전력공학",
          "전기기기",
          "회로이론 및 제어공학",
          "전기설비기술기준"
        ],
        "nextStage": "실기",
        "minimum": 40,
        "average": 60
      },
      {
        "id": "실기",
        "subjects": ["전기설비설계 및 관리"],
        "minimum": 60,
        "average": 60
      }
    ],
    "schedules": [
      {
        "round": "1회",
        "stage": "필기",
        "examDate": "2026-01-30",
        "examEndsOn": "2026-03-03",
        "resultDate": "2026-03-11",
        "registrationWindows": [
          {
            "startsAt": "2026-01-12T01:00:00.000Z",
            "endsAt": "2026-01-15T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "1회",
        "stage": "실기",
        "examDate": "2026-04-18",
        "examEndsOn": "2026-05-06",
        "resultDate": "2026-06-12",
        "registrationWindows": [
          {
            "startsAt": "2026-03-23T01:00:00.000Z",
            "endsAt": "2026-03-26T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "2회",
        "stage": "필기",
        "examDate": "2026-05-09",
        "examEndsOn": "2026-05-29",
        "resultDate": "2026-06-10",
        "registrationWindows": [
          {
            "startsAt": "2026-04-20T01:00:00.000Z",
            "endsAt": "2026-04-23T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "2회",
        "stage": "실기",
        "examDate": "2026-07-18",
        "examEndsOn": "2026-08-05",
        "resultDate": "2026-09-11",
        "registrationWindows": [
          {
            "startsAt": "2026-06-22T01:00:00.000Z",
            "endsAt": "2026-06-25T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "3회",
        "stage": "필기",
        "examDate": "2026-08-07",
        "examEndsOn": "2026-09-01",
        "resultDate": "2026-09-09",
        "registrationWindows": [
          {
            "startsAt": "2026-07-20T01:00:00.000Z",
            "endsAt": "2026-07-23T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "3회",
        "stage": "실기",
        "examDate": "2026-10-24",
        "examEndsOn": "2026-11-13",
        "resultDate": "2026-12-18",
        "registrationWindows": [
          {
            "startsAt": "2026-09-21T01:00:00.000Z",
            "endsAt": "2026-09-28T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      }
    ]
  },
  {
    "id": "electrical-industrial",
    "slug": "electrical-industrial",
    "title": "전기산업기사",
    "category": "국가자격",
    "dataYear": 2026,
    "sourceUrl": "https://www.q-net.or.kr/crf005.do?id=crf00503s02&jmCd=2140&jmInfoDivCcd=B0",
    "checkedAt": "2026-10-19",
    "notice": "2027 일정 공고 전 · 과목과 일정은 2026년 기준이에요. 공식 공고가 우선해요.",
    "supplies": ["수험표 확인", "인정 신분증", "시험장·입실 시간 확인", "공식 지참 준비물 확인"],
    "stages": [
      {
        "id": "필기",
        "subjects": ["전기자기학", "전력공학", "전기기기", "회로이론", "전기설비기술기준"],
        "nextStage": "실기",
        "minimum": 40,
        "average": 60
      },
      {
        "id": "실기",
        "subjects": ["전기설비설계 및 관리"],
        "minimum": 60,
        "average": 60
      }
    ],
    "schedules": [
      {
        "round": "1회",
        "stage": "필기",
        "examDate": "2026-01-30",
        "examEndsOn": "2026-03-03",
        "resultDate": "2026-03-11",
        "registrationWindows": [
          {
            "startsAt": "2026-01-12T01:00:00.000Z",
            "endsAt": "2026-01-15T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "1회",
        "stage": "실기",
        "examDate": "2026-04-18",
        "examEndsOn": "2026-05-06",
        "resultDate": "2026-06-12",
        "registrationWindows": [
          {
            "startsAt": "2026-03-23T01:00:00.000Z",
            "endsAt": "2026-03-26T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "2회",
        "stage": "필기",
        "examDate": "2026-05-09",
        "examEndsOn": "2026-05-29",
        "resultDate": "2026-06-10",
        "registrationWindows": [
          {
            "startsAt": "2026-04-20T01:00:00.000Z",
            "endsAt": "2026-04-23T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "2회",
        "stage": "실기",
        "examDate": "2026-07-18",
        "examEndsOn": "2026-08-05",
        "resultDate": "2026-09-11",
        "registrationWindows": [
          {
            "startsAt": "2026-06-22T01:00:00.000Z",
            "endsAt": "2026-06-25T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "3회",
        "stage": "필기",
        "examDate": "2026-08-07",
        "examEndsOn": "2026-09-01",
        "resultDate": "2026-09-09",
        "registrationWindows": [
          {
            "startsAt": "2026-07-20T01:00:00.000Z",
            "endsAt": "2026-07-23T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "3회",
        "stage": "실기",
        "examDate": "2026-10-24",
        "examEndsOn": "2026-11-13",
        "resultDate": "2026-12-18",
        "registrationWindows": [
          {
            "startsAt": "2026-09-21T01:00:00.000Z",
            "endsAt": "2026-09-28T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      }
    ]
  },
  {
    "id": "industrial-safety",
    "slug": "industrial-safety",
    "title": "산업안전기사",
    "category": "국가자격",
    "dataYear": 2026,
    "sourceUrl": "https://www.q-net.or.kr/crf005.do?id=crf00503s02&jmCd=1431&jmInfoDivCcd=B0",
    "checkedAt": "2026-10-19",
    "notice": "2027 일정 공고 전 · 과목과 일정은 2026년 기준이에요. 공식 공고가 우선해요.",
    "supplies": ["수험표 확인", "인정 신분증", "시험장·입실 시간 확인", "공식 지참 준비물 확인"],
    "stages": [
      {
        "id": "필기",
        "subjects": [
          "산업재해 예방 및 안전보건교육",
          "인간공학 및 위험성 평가·관리",
          "기계·기구 및 설비 안전 관리",
          "전기설비 안전 관리",
          "화학설비 안전 관리",
          "건설공사 안전 관리"
        ],
        "nextStage": "실기",
        "minimum": 40,
        "average": 60
      },
      {
        "id": "실기",
        "subjects": ["산업안전관리실무"],
        "minimum": 60,
        "average": 60
      }
    ],
    "schedules": [
      {
        "round": "1회",
        "stage": "필기",
        "examDate": "2026-01-30",
        "examEndsOn": "2026-03-03",
        "resultDate": "2026-03-11",
        "registrationWindows": [
          {
            "startsAt": "2026-01-12T01:00:00.000Z",
            "endsAt": "2026-01-15T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "1회",
        "stage": "실기",
        "examDate": "2026-04-18",
        "examEndsOn": "2026-05-06",
        "resultDate": "2026-06-12",
        "registrationWindows": [
          {
            "startsAt": "2026-03-23T01:00:00.000Z",
            "endsAt": "2026-03-26T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "2회",
        "stage": "필기",
        "examDate": "2026-05-09",
        "examEndsOn": "2026-05-29",
        "resultDate": "2026-06-10",
        "registrationWindows": [
          {
            "startsAt": "2026-04-20T01:00:00.000Z",
            "endsAt": "2026-04-23T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "2회",
        "stage": "실기",
        "examDate": "2026-07-18",
        "examEndsOn": "2026-08-05",
        "resultDate": "2026-09-11",
        "registrationWindows": [
          {
            "startsAt": "2026-06-22T01:00:00.000Z",
            "endsAt": "2026-06-25T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "3회",
        "stage": "필기",
        "examDate": "2026-08-07",
        "examEndsOn": "2026-09-01",
        "resultDate": "2026-09-09",
        "registrationWindows": [
          {
            "startsAt": "2026-07-20T01:00:00.000Z",
            "endsAt": "2026-07-23T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "3회",
        "stage": "실기",
        "examDate": "2026-10-24",
        "examEndsOn": "2026-11-13",
        "resultDate": "2026-12-18",
        "registrationWindows": [
          {
            "startsAt": "2026-09-21T01:00:00.000Z",
            "endsAt": "2026-09-28T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      }
    ]
  },
  {
    "id": "fire-equipment-electrical",
    "slug": "fire-equipment-electrical",
    "title": "소방설비기사 전기",
    "category": "국가자격",
    "dataYear": 2026,
    "sourceUrl": "https://www.q-net.or.kr/crf005.do?id=crf00503s02&jmCd=1910&jmInfoDivCcd=B0",
    "checkedAt": "2026-10-19",
    "notice": "2027 일정 공고 전 · 과목과 일정은 2026년 기준이에요. 공식 공고가 우선해요.",
    "supplies": ["수험표 확인", "인정 신분증", "시험장·입실 시간 확인", "공식 지참 준비물 확인"],
    "stages": [
      {
        "id": "필기",
        "subjects": ["소방원론", "소방전기일반", "소방관계법규", "소방전기시설의 구조 및 원리"],
        "nextStage": "실기",
        "minimum": 40,
        "average": 60
      },
      {
        "id": "실기",
        "subjects": ["소방전기시설 설계 및 시공실무"],
        "minimum": 60,
        "average": 60
      }
    ],
    "schedules": [
      {
        "round": "1회",
        "stage": "필기",
        "examDate": "2026-01-30",
        "examEndsOn": "2026-03-03",
        "resultDate": "2026-03-11",
        "registrationWindows": [
          {
            "startsAt": "2026-01-12T01:00:00.000Z",
            "endsAt": "2026-01-15T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "1회",
        "stage": "실기",
        "examDate": "2026-04-18",
        "examEndsOn": "2026-05-06",
        "resultDate": "2026-06-12",
        "registrationWindows": [
          {
            "startsAt": "2026-03-23T01:00:00.000Z",
            "endsAt": "2026-03-26T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "2회",
        "stage": "필기",
        "examDate": "2026-05-09",
        "examEndsOn": "2026-05-29",
        "resultDate": "2026-06-10",
        "registrationWindows": [
          {
            "startsAt": "2026-04-20T01:00:00.000Z",
            "endsAt": "2026-04-23T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "2회",
        "stage": "실기",
        "examDate": "2026-07-18",
        "examEndsOn": "2026-08-05",
        "resultDate": "2026-09-11",
        "registrationWindows": [
          {
            "startsAt": "2026-06-22T01:00:00.000Z",
            "endsAt": "2026-06-25T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "3회",
        "stage": "필기",
        "examDate": "2026-08-07",
        "examEndsOn": "2026-09-01",
        "resultDate": "2026-09-09",
        "registrationWindows": [
          {
            "startsAt": "2026-07-20T01:00:00.000Z",
            "endsAt": "2026-07-23T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "3회",
        "stage": "실기",
        "examDate": "2026-10-24",
        "examEndsOn": "2026-11-13",
        "resultDate": "2026-12-18",
        "registrationWindows": [
          {
            "startsAt": "2026-09-21T01:00:00.000Z",
            "endsAt": "2026-09-28T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      }
    ]
  },
  {
    "id": "hazardous-materials",
    "slug": "hazardous-materials",
    "title": "위험물산업기사",
    "category": "국가자격",
    "dataYear": 2026,
    "sourceUrl": "https://www.q-net.or.kr/crf005.do?id=crf00503s02&jmCd=2121&jmInfoDivCcd=B0",
    "checkedAt": "2026-10-19",
    "notice": "2027 일정 공고 전 · 과목과 일정은 2026년 기준이에요. 공식 공고가 우선해요.",
    "supplies": ["수험표 확인", "인정 신분증", "시험장·입실 시간 확인", "공식 지참 준비물 확인"],
    "stages": [
      {
        "id": "필기",
        "subjects": ["물질의 물리화학적 성질", "화재예방과 소화방법", "위험물의 성질 및 취급"],
        "nextStage": "실기",
        "minimum": 40,
        "average": 60
      },
      {
        "id": "실기",
        "subjects": ["위험물 취급 실무"],
        "minimum": 60,
        "average": 60
      }
    ],
    "schedules": [
      {
        "round": "1회",
        "stage": "필기",
        "examDate": "2026-01-30",
        "examEndsOn": "2026-03-03",
        "resultDate": "2026-03-11",
        "registrationWindows": [
          {
            "startsAt": "2026-01-12T01:00:00.000Z",
            "endsAt": "2026-01-15T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "1회",
        "stage": "실기",
        "examDate": "2026-04-18",
        "examEndsOn": "2026-05-06",
        "resultDate": "2026-06-12",
        "registrationWindows": [
          {
            "startsAt": "2026-03-23T01:00:00.000Z",
            "endsAt": "2026-03-26T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "2회",
        "stage": "필기",
        "examDate": "2026-05-09",
        "examEndsOn": "2026-05-29",
        "resultDate": "2026-06-10",
        "registrationWindows": [
          {
            "startsAt": "2026-04-20T01:00:00.000Z",
            "endsAt": "2026-04-23T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "2회",
        "stage": "실기",
        "examDate": "2026-07-18",
        "examEndsOn": "2026-08-05",
        "resultDate": "2026-09-11",
        "registrationWindows": [
          {
            "startsAt": "2026-06-22T01:00:00.000Z",
            "endsAt": "2026-06-25T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "3회",
        "stage": "필기",
        "examDate": "2026-08-07",
        "examEndsOn": "2026-09-01",
        "resultDate": "2026-09-09",
        "registrationWindows": [
          {
            "startsAt": "2026-07-20T01:00:00.000Z",
            "endsAt": "2026-07-23T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "3회",
        "stage": "실기",
        "examDate": "2026-10-24",
        "examEndsOn": "2026-11-13",
        "resultDate": "2026-12-18",
        "registrationWindows": [
          {
            "startsAt": "2026-09-21T01:00:00.000Z",
            "endsAt": "2026-09-28T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      }
    ]
  },
  {
    "id": "realtor-1",
    "slug": "realtor",
    "title": "공인중개사 1차",
    "category": "국가자격",
    "dataYear": 2026,
    "sourceUrl": "https://www.q-net.or.kr/crf005.do?id=crf00503s02&jmCd=9630&jmInfoDivCcd=B0",
    "checkedAt": "2026-10-19",
    "notice": "2027 일정 공고 전 · 과목과 일정은 2026년 기준이에요. 공식 공고가 우선해요.",
    "supplies": ["수험표 확인", "인정 신분증", "시험장·입실 시간 확인", "공식 지참 준비물 확인"],
    "stages": [
      {
        "id": "1차",
        "subjects": ["부동산학개론", "민법 및 민사특별법"],
        "minimum": 40,
        "average": 60,
        "nextStage": "2차"
      }
    ],
    "schedules": [
      {
        "round": "37회",
        "stage": "1차",
        "examDate": "2026-10-31",
        "examEndsOn": "2026-10-31",
        "resultDate": "2026-12-02",
        "registrationWindows": [
          {
            "startsAt": "2026-08-03T01:00:00.000Z",
            "endsAt": "2026-08-07T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      }
    ]
  },
  {
    "id": "realtor-2",
    "slug": "realtor",
    "title": "공인중개사 2차",
    "category": "국가자격",
    "dataYear": 2026,
    "sourceUrl": "https://www.q-net.or.kr/crf005.do?id=crf00503s02&jmCd=9630&jmInfoDivCcd=B0",
    "checkedAt": "2026-10-19",
    "notice": "2027 일정 공고 전 · 과목과 일정은 2026년 기준이에요. 공식 공고가 우선해요.",
    "supplies": ["수험표 확인", "인정 신분증", "시험장·입실 시간 확인", "공식 지참 준비물 확인"],
    "stages": [
      {
        "id": "2차",
        "subjects": ["공인중개사법령 및 중개실무", "부동산공법", "부동산공시법 및 세법"],
        "minimum": 40,
        "average": 60
      }
    ],
    "schedules": [
      {
        "round": "37회",
        "stage": "2차",
        "examDate": "2026-10-31",
        "examEndsOn": "2026-10-31",
        "resultDate": "2026-12-02",
        "registrationWindows": [
          {
            "startsAt": "2026-08-03T01:00:00.000Z",
            "endsAt": "2026-08-07T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      }
    ]
  },
  {
    "id": "housing-manager",
    "slug": "housing-manager",
    "title": "주택관리사보",
    "category": "국가자격",
    "dataYear": 2026,
    "sourceUrl": "https://www.q-net.or.kr/crf005.do?id=crf00503s02&jmCd=9744&jmInfoDivCcd=B0",
    "checkedAt": "2026-10-19",
    "notice": "2027 일정 공고 전 · 과목과 일정은 2026년 기준이에요. 공식 공고가 우선해요. 2차는 선발예정인원 내 고득점 순이에요.",
    "supplies": ["수험표 확인", "인정 신분증", "시험장·입실 시간 확인", "공식 지참 준비물 확인"],
    "stages": [
      {
        "id": "1차",
        "subjects": ["회계원리", "공동주택시설개론", "민법"],
        "minimum": 40,
        "average": 60,
        "nextStage": "2차"
      },
      {
        "id": "2차",
        "subjects": ["주택관리 관계법규", "공동주택관리실무"],
        "minimum": 40,
        "average": 60
      }
    ],
    "schedules": [
      {
        "round": "29회",
        "stage": "1차",
        "examDate": "2026-06-27",
        "examEndsOn": "2026-06-27",
        "resultDate": "2026-07-29",
        "registrationWindows": [
          {
            "startsAt": "2026-05-11T01:00:00.000Z",
            "endsAt": "2026-05-15T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      },
      {
        "round": "29회",
        "stage": "2차",
        "examDate": "2026-09-19",
        "examEndsOn": "2026-09-19",
        "resultDate": "2026-12-02",
        "registrationWindows": [
          {
            "startsAt": "2026-08-10T01:00:00.000Z",
            "endsAt": "2026-08-14T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      }
    ]
  },
  {
    "id": "social-worker-1",
    "slug": "social-worker-1",
    "title": "사회복지사 1급",
    "category": "국가자격",
    "dataYear": 2026,
    "sourceUrl": "https://www.q-net.or.kr/site/welfare",
    "checkedAt": "2026-10-19",
    "notice": "2027 일정 공고 전 · 과목과 일정은 2026년 기준이에요. 공식 공고가 우선해요.",
    "supplies": ["수험표 확인", "인정 신분증", "시험장·입실 시간 확인", "공식 지참 준비물 확인"],
    "stages": [
      {
        "id": "필기",
        "subjects": ["사회복지기초", "사회복지실천", "사회복지정책과 제도"],
        "minimum": 40,
        "average": 60
      }
    ],
    "schedules": [
      {
        "round": "24회",
        "stage": "필기",
        "examDate": "2026-01-17",
        "examEndsOn": "2026-01-17",
        "resultDate": "2026-03-25",
        "registrationWindows": [
          {
            "startsAt": "2025-12-08T00:00:00.000Z",
            "endsAt": "2025-12-12T09:00:00.000Z",
            "label": "원서접수"
          }
        ]
      }
    ]
  }
]
